const proxyUrl = 'https://cors-anywhere.herokuapp.com/'

export const reCaptcha = {
  base: 'https://www.google.com/recaptcha/api/siteverify?',
  secret: '6Lex1OoUAAAAAG6JYo_11AXT4xuP9TtY1-PUHfnR',
  sitekey: '6Lex1OoUAAAAAB4LE6F-C7Ice3gWVs5jWTxacKB2'
}

export function verifySuccess (token, callback) {
  const targetUrl = `${reCaptcha.base}secret=${reCaptcha.secret}&response=${token}`

  try {
    fetch(proxyUrl + targetUrl)
      .then(res => res.json())
      .then(result => {
        if(!result.success){
        	console.log('There was an error during the security check.')
        }
      })
  } catch (error) {
      console.log('Error checking ReCaptcha token: ', error)
  	}
}
